<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Challan Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="current_academic_year"
            :items="academic_year_list"
            item-text="ay"
            return-object
            label="Academic Year"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col sm="8">
          <v-icon color="error">*</v-icon>
          From Date ::
          <input
            class="mt-7 pt-0"
            id="datePickerId"
            type="date"
            v-model="fromdate"
          />
          <v-icon color="error" class="ml-3">*</v-icon>
          To Date ::
          <input
            class="mt-7 ml-2 pt-0"
            id="datePickerId"
            type="date"
            v-model="todate"
          />
        </v-col>
        <v-btn
          @click="getReport()"
          :disabled="
            current_academic_year == null || fromdate == null || todate == null
          "
          :loading="loader"
          class="button mt-7 pt-0"
          >Proceed</v-btn
        >
      </v-row>
    </v-card>
    <v-card class="box" v-if="challan_records != ''">
      <v-data-table
        v-if="challan_records.length > 0"
        dense
        :headers="headers"
        :items="bookList1"
        :search="search"
        class="elevation-1 mytable"
        @current-items="getFiltered"
      >
        <template v-slot:top class="pb-5">
          <v-row justify="center" align="center">
            <tr class="t-row">
              <div>
                <th>
                  <v-col cols="12" sm="12" md="12">
                    <v-row>
                      <download-excel
                        class="mr-2 pb-3 pt-2"
                        :data="bookList1"
                        :fields="table_fields"
                        worksheet="Student_List"
                        name="Student_List.xls"
                      >
                        <v-btn color="success" outlined rounded>
                          <v-icon dark>mdi-file-excel</v-icon> Export
                        </v-btn>
                      </download-excel>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete
                            class="mr-2 pb-5 pt-2"
                            flat
                            hide-details
                            small
                            rounded
                            dense
                            outlined
                            color="#0F2027"
                            :label="header.text"
                            multiple
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                          ></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </v-col>
                </th>
              </div>
            </tr>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    academic_year_list: null,
    current_academic_year: null,
    challan_records: [],
    loader: false,
    filterArr: [],
    fromdate: null,
    todate: null,
    filters: {
      standard: [],
      division: [],
      prn_no: [],
      exam_name: [],
    },
    table_fields: {
      "Sr. No": "srno",
      "PRN. Number": "prn_no",
      "Student Name": "stud_name",
      "Challan No.": "challan_no",
      Standard: "standard",
      "Payment Type": "payment_type",
      Amount: "amount",
      Remark: "remark",
      "Challan Status": "challan_status",
      "Paid Date": "paid_date",
      "Generated Date": "generated_date",
    },
    headers: [
      { text: "Sr. No.", value: "srno", sortable: false },
      { text: "Student Name", value: "stud_name", sortable: false },
      { text: "PRN No.", value: "prn_no", sortable: false },
      { text: "Challan No.", value: "challan_no", sortable: false },
      { text: "Standard", value: "standard", sortable: false },
      { text: "Payment Type", value: "payment_type", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Remark", value: "remark", sortable: false },
      { text: "Challan Status", value: "challan_status", sortable: false },
      { text: "Paid Date", value: "paid_date", sortable: false },
      { text: "Generated Date", value: "generated_date", sortable: false },
    ],
  }),
  computed: {
    bookList1() {
      return this.challan_records.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  methods: {
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      return this.challan_records.map((d) => d[val]);
    },
    getReport() {
      if (this.current_academic_year == null) {
        alert("Please select AY!!!");
        return;
      }
      if (this.fromdate == null) {
        alert("Please select From Date!!!");
        return;
      }
      if (this.todate == null) {
        alert("Please select To Date!!!");
        return;
      }
      const formData = {
        ay: this.current_academic_year.id,
        fromdate: this.fromdate,
        todate: this.todate,
      };
      this.loader = true;
      axios
        .post("/AccountingAndFeesReports/challanReport", formData)
        .then((res) => {
          this.challan_records = res.data.challan_records;
          this.loader = false;
        })
        .catch((error) => {
          window.console.log(error);
          this.loader = false;
        })
        .finally(() => {
          //close loader
          this.loader = false;
        });
    },
    get_ay_std() {
      //api-1
      axios
        .post("/InstallmentStructureDetails/getAllData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.academic_year_list = res.data.ay_data;
            this.current_academic_year = res.data.cay;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {
          //close loader
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.get_ay_std();
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.mytable2 /deep/ thead th {
  /* background: #2980b9 !important; fallback for old browsers */
  background-color: #2980b9 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
